import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import DashboardAnalytics from "../pages/DashboardAnalytics";
import DashboardCrm from "../pages/DashboardCrm";
import DashboardCrypto from "../pages/DashboardCrypto";
import DashboardProject from "../pages/DashboardProject";
import DashboardNFT from "../pages/DashboardNFT";
import DashboardJob from "../pages/DashboardJob/";

// // Email box
import MailInbox from "../pages/EmailInbox";
import BasicAction from "../pages/Email/EmailTemplates/BasicAction";
import EcommerceAction from "../pages/Email/EmailTemplates/EcommerceAction";

// //Chat
import Chat from "../pages/Chat";

// //Calendar
import Calendar from "../pages/Calendar";
import MonthGrid from "../pages/Calendar/monthGrid";

// // Project
import ProjectList from "../pages/Projects/ProjectList";
import ProjectOverview from "../pages/Projects/ProjectOverview";
import CreateProject from "../pages/Projects/CreateProject";

// //Task
import TaskDetails from "../pages/Tasks/TaskDetails";
import TaskList from "../pages/Tasks/TaskList";

// //Transactions
import Transactions from '../pages/Crypto/Transactions';
import BuySell from '../pages/Crypto/BuySell';
import CryproOrder from '../pages/Crypto/CryptoOrder';
import MyWallet from '../pages/Crypto/MyWallet';
import ICOList from '../pages/Crypto/ICOList';
import KYCVerification from '../pages/Crypto/KYCVerification';

// //Crm Pages
import CrmCompanies from "../pages/Crm/CrmCompanies";
import CrmContacts from "../pages/Crm/CrmContacts";
import CrmDeals from "../pages/Crm/CrmDeals/index";
import CrmLeads from "../pages/Crm/CrmLeads/index";

// Adatis — Cadastros
import StudioDashboard from "../pages/Adatis/Studio/Dashboard";
import ClientsList from "../pages/Adatis/Studio/Clients";
import ClientDetail from "../pages/Adatis/Studio/Clients/Detail";
import ProfessionalsList from "../pages/Adatis/Studio/Professionals";
import UnitsList from "../pages/Adatis/Studio/Units";
import UsersList from "../pages/Adatis/Studio/Users";
import OrdersList from "../pages/Adatis/Studio/Orders";
import AgendaList from "../pages/Adatis/Studio/Agenda";
import CounterLookup from "../pages/Adatis/Studio/CounterLookup";
import ProductsList from "../pages/Adatis/Studio/Products";
import InventoryValuationPage from "../pages/Adatis/Studio/Products/InventoryValuation";
import ExpensesList from "../pages/Adatis/Studio/Financial/Expenses";
import DreReport from "../pages/Adatis/Studio/Financial/Dre";
import DayCloseReportPage from "../pages/Adatis/Studio/Financial/DayClose";
import ServicesList from "../pages/Adatis/Studio/Services";
import ServiceBundlesList from "../pages/Adatis/Studio/ServiceBundles";
import ServicePackagesList from "../pages/Adatis/Studio/ServicePackages";
import CrmPage from "../pages/Adatis/Studio/Crm";
import ClientSubscriptionPlansList from "../pages/Adatis/Studio/ClientSubscriptionPlans";
import AnamnesisTemplatesPage from "../pages/Adatis/Studio/Settings/AnamnesisTemplates";
import IntegrationsPage from "../pages/Integrations";
import Billing from "../pages/Adatis/Shared/Billing";
import Suspended from "../pages/Adatis/Studio/Suspended";
import AccountSettings from "../pages/Settings/AccountSettings";
import CatalogCategoriesPage from "../pages/Settings/CatalogCategories";
import ClientTagsPage from "../pages/Settings/ClientTags";
import ClinicalChecklistTemplatesPage from "../pages/Settings/ClinicalChecklistTemplates";
import ClinicalMapRegionsPage from "../pages/Settings/ClinicalMapRegions";
import OperationSettings from "../pages/Settings/Operation";
import GeneralSettings from "../pages/Settings/GeneralSettings";
import CalendarExceptionsPage from "../pages/Settings/CalendarExceptions";
import PaymentSettingsPage from "../pages/Settings/Payments";
import EmailNotificationsSettingsPage from "../pages/Settings/EmailNotifications";
import ContactRulerPage from "../pages/Marketing/ContactRuler";
import EmailCampaignsPage from "../pages/Marketing/EmailCampaigns";

import MessagingSettingsPage from "../pages/Settings/Messaging";
import WhatsappExtensionSettingsPage from "../pages/Settings/WhatsappExtension";
import TeamPermissionsPage from "../pages/Settings/TeamPermissions";
import SubscriptionSettings from "../pages/Settings/SubscriptionSettings";
import HelpPage from "../pages/Help";

// Adatis — Super Admin
import SuperAdminLogin from "../pages/Adatis/SuperAdmin/Login";
import SuperAdminDashboard from "../pages/Adatis/SuperAdmin/Dashboard";
import SuperAdminConcierge from "../pages/Adatis/SuperAdmin/Concierge";
import SuperAdminTrialQueue from "../pages/Adatis/SuperAdmin/TrialQueue";
import SuperAdminCsNurture from "../pages/Adatis/SuperAdmin/CsNurture";
import SuperAdminPlans from "../pages/Adatis/SuperAdmin/Plans";
import SuperAdminPromotionCoupons from "../pages/Adatis/SuperAdmin/PromotionCoupons";
import SuperAdminBlog from "../pages/Adatis/SuperAdmin/Blog";
import SuperAdminHealthRecordPresets from "../pages/Adatis/SuperAdmin/HealthRecordPresets";
import SuperAdminTenants from "../pages/Adatis/SuperAdmin/Tenants";
import SuperAdminTenantTeam from "../pages/Adatis/SuperAdmin/Tenants/Team";
import SuperAdminAccounts from "../pages/Adatis/SuperAdmin/Accounts";
import SuperAdminActivityLogs from "../pages/Adatis/SuperAdmin/ActivityLogs";
import SuperAdminWebhookLogs from "../pages/Adatis/SuperAdmin/WebhookLogs";
import SuperAdminEmailSuppressions from "../pages/Adatis/SuperAdmin/EmailSuppressions";
import SuperAdminSupportConversations from "../pages/Adatis/SuperAdmin/SupportConversations";
import SuperAdminSupportTickets from "../pages/Adatis/SuperAdmin/SupportTickets";
import SupportChatPage from "../pages/Adatis/Studio/Support/Chat";
import SupportTicketsPage from "../pages/Adatis/Studio/Support/Tickets";
import VisualLabPage from "../pages/Adatis/Studio/Settings/VisualLab";

// //Invoices
import InvoiceList from "../pages/Invoices/InvoiceList";
import InvoiceCreate from "../pages/Invoices/InvoiceCreate";
import InvoiceDetails from "../pages/Invoices/InvoiceDetails";

// // Support Tickets
import ListView from '../pages/SupportTickets/ListView';
import TicketsDetails from '../pages/SupportTickets/TicketsDetails';

// // //Ecommerce Pages
import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts/index";
import EcommerceProductDetail from "../pages/Ecommerce/EcommerceProducts/EcommerceProductDetail";
import EcommerceAddProduct from "../pages/Ecommerce/EcommerceProducts/EcommerceAddProduct";
import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index";
import EcommerceOrderDetail from "../pages/Ecommerce/EcommerceOrders/EcommerceOrderDetail";
import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index";
import EcommerceCart from "../pages/Ecommerce/EcommerceCart";
import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout";
import EcommerceSellers from "../pages/Ecommerce/EcommerceSellers/index";
import EcommerceSellerDetail from "../pages/Ecommerce/EcommerceSellers/EcommerceSellerDetail";

// // NFT Marketplace Pages
import Marketplace from "../pages/NFTMarketplace/Marketplace";
import Collections from "../pages/NFTMarketplace/Collections";
import CreateNFT from "../pages/NFTMarketplace/CreateNFT";
import Creators from "../pages/NFTMarketplace/Creators";
import ExploreNow from "../pages/NFTMarketplace/ExploreNow";
import ItemDetails from "../pages/NFTMarketplace/Itemdetails";
import LiveAuction from "../pages/NFTMarketplace/LiveAuction";
import Ranking from "../pages/NFTMarketplace/Ranking";
import WalletConnect from "../pages/NFTMarketplace/WalletConnect";

// // Base Ui
import UiAlerts from "../pages/BaseUi/UiAlerts/UiAlerts";
import UiBadges from "../pages/BaseUi/UiBadges/UiBadges";
import UiButtons from "../pages/BaseUi/UiButtons/UiButtons";
import UiColors from "../pages/BaseUi/UiColors/UiColors";
import UiCards from "../pages/BaseUi/UiCards/UiCards";
import UiCarousel from "../pages/BaseUi/UiCarousel/UiCarousel";
import UiDropdowns from "../pages/BaseUi/UiDropdowns/UiDropdowns";
import UiGrid from "../pages/BaseUi/UiGrid/UiGrid";
import UiImages from "../pages/BaseUi/UiImages/UiImages";
import UiTabs from "../pages/BaseUi/UiTabs/UiTabs";
import UiAccordions from "../pages/BaseUi/UiAccordion&Collapse/UiAccordion&Collapse";
import UiModals from "../pages/BaseUi/UiModals/UiModals";
import UiOffcanvas from "../pages/BaseUi/UiOffcanvas/UiOffcanvas";
import UiPlaceholders from "../pages/BaseUi/UiPlaceholders/UiPlaceholders";
import UiProgress from "../pages/BaseUi/UiProgress/UiProgress";
import UiNotifications from "../pages/BaseUi/UiNotifications/UiNotifications";
import UiMediaobject from "../pages/BaseUi/UiMediaobject/UiMediaobject";
import UiEmbedVideo from "../pages/BaseUi/UiEmbedVideo/UiEmbedVideo";
import UiTypography from "../pages/BaseUi/UiTypography/UiTypography";
import UiList from "../pages/BaseUi/UiLists/UiLists";
import UiGeneral from "../pages/BaseUi/UiGeneral/UiGeneral";
import UiRibbons from "../pages/BaseUi/UiRibbons/UiRibbons";
import UiUtilities from "../pages/BaseUi/UiUtilities/UiUtilities";

// // Advance Ui
import UiScrollbar from "../pages/AdvanceUi/UiScrollbar/UiScrollbar";
import UiAnimation from "../pages/AdvanceUi/UiAnimation/UiAnimation";
import UiSwiperSlider from "../pages/AdvanceUi/UiSwiperSlider/UiSwiperSlider";
import UiRatings from "../pages/AdvanceUi/UiRatings/UiRatings";
import UiHighlight from "../pages/AdvanceUi/UiHighlight/UiHighlight";

// // Widgets
import Widgets from '../pages/Widgets/Index';

// //Forms
import BasicElements from "../pages/Forms/BasicElements/BasicElements";
import FormSelect from "../pages/Forms/FormSelect/FormSelect";
import FormEditor from "../pages/Forms/FormEditor/FormEditor";
import CheckBoxAndRadio from "../pages/Forms/CheckboxAndRadio/CheckBoxAndRadio";
import Masks from "../pages/Forms/Masks/Masks";
import FileUpload from "../pages/Forms/FileUpload/FileUpload";
import FormPickers from "../pages/Forms/FormPickers/FormPickers";
import FormRangeSlider from "../pages/Forms/FormRangeSlider/FormRangeSlider";
import Formlayouts from "../pages/Forms/FormLayouts/Formlayouts";
import FormValidation from "../pages/Forms/FormValidation/FormValidation";
import FormWizard from "../pages/Forms/FormWizard/FormWizard";
import FormAdvanced from "../pages/Forms/FormAdvanced/FormAdvanced";
import Select2 from "../pages/Forms/Select2/Select2";

// //Tables
import BasicTables from '../pages/Tables/BasicTables/BasicTables';
// import ListTables from '../pages/Tables/ListTables/ListTables';
import ReactTable from "../pages/Tables/ReactTables";

// //Icon pages
import RemixIcons from "../pages/Icons/RemixIcons/RemixIcons";
import BoxIcons from "../pages/Icons/BoxIcons/BoxIcons";
import MaterialDesign from "../pages/Icons/MaterialDesign/MaterialDesign";
import FeatherIcons from "../pages/Icons/FeatherIcons/FeatherIcons";
import LineAwesomeIcons from "../pages/Icons/LineAwesomeIcons/LineAwesomeIcons";
import CryptoIcons from "../pages/Icons/CryptoIcons/CryptoIcons";

// //Maps
import GoogleMaps from "../pages/Maps/GoogleMaps/GoogleMaps";

// //AuthenticationInner pages
import BasicSignIn from '../pages/AuthenticationInner/Login/BasicSignIn';
import CoverSignIn from '../pages/AuthenticationInner/Login/CoverSignIn';
import BasicSignUp from '../pages/AuthenticationInner/Register/BasicSignUp';
import CoverSignUp from "../pages/AuthenticationInner/Register/CoverSignUp";
import BasicPasswReset from '../pages/AuthenticationInner/PasswordReset/BasicPasswReset';
// //pages
import Starter from '../pages/Pages/Starter/Starter';
import SimplePage from '../pages/Pages/Profile/SimplePage/SimplePage';
import Settings from '../pages/Pages/Profile/Settings/Settings';
import Team from '../pages/Pages/Team/Team';
import Timeline from '../pages/Pages/Timeline/Timeline';
import Faqs from '../pages/Pages/Faqs/Faqs';
import Pricing from '../pages/Pages/Pricing/Pricing';
import Gallery from '../pages/Pages/Gallery/Gallery';
import Maintenance from '../pages/Pages/Maintenance/Maintenance';
import ComingSoon from '../pages/Pages/ComingSoon/ComingSoon';
import SiteMap from '../pages/Pages/SiteMap/SiteMap';
import SearchResults from '../pages/Pages/SearchResults/SearchResults';

import CoverPasswReset from '../pages/AuthenticationInner/PasswordReset/CoverPasswReset';
import BasicLockScreen from '../pages/AuthenticationInner/LockScreen/BasicLockScr';
import CoverLockScreen from '../pages/AuthenticationInner/LockScreen/CoverLockScr';
import BasicLogout from "pages/AuthenticationInner/Logout/BasicLogout";
import CoverLogout from '../pages/AuthenticationInner/Logout/CoverLogout';
import BasicSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg';
import CoverSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg';
import BasicTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify';
import CoverTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/CoverTwosVerify';
import Basic404 from '../pages/AuthenticationInner/Errors/Basic404';
import Cover404 from '../pages/AuthenticationInner/Errors/Cover404';
import Alt404 from '../pages/AuthenticationInner/Errors/Alt404';
import Error500 from '../pages/AuthenticationInner/Errors/Error500';

import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";
import CoverPasswCreate from "../pages/AuthenticationInner/PasswordCreate/CoverPasswCreate";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";

// //APi Key
import APIKey from "../pages/APIKey/index";

// //login
import Login from "../pages/Authentication/Login";
import InviteSetup from "../pages/Authentication/InviteSetup";
import GoogleCallback from "../pages/Authentication/GoogleCallback";
import GoogleMobileCallback from "../pages/Authentication/GoogleMobileCallback";
import SelectStudio from "../pages/Adatis/Studio/SelectStudio";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

//Charts
import LineCharts from "../pages/Charts/ApexCharts/LineCharts";
import AreaCharts from "../pages/Charts/ApexCharts/AreaCharts";
import ColumnCharts from "../pages/Charts/ApexCharts/ColumnCharts";
import BarCharts from "../pages/Charts/ApexCharts/BarCharts";
import MixedCharts from "../pages/Charts/ApexCharts/MixedCharts";
import TimelineCharts from "../pages/Charts/ApexCharts/TimelineCharts";
import CandlestickChart from "../pages/Charts/ApexCharts/CandlestickChart";
import BoxplotCharts from "../pages/Charts/ApexCharts/BoxplotCharts";
import BubbleChart from "../pages/Charts/ApexCharts/BubbleChart";
import ScatterCharts from "../pages/Charts/ApexCharts/ScatterCharts";
import HeatmapCharts from "../pages/Charts/ApexCharts/HeatmapCharts";
import TreemapCharts from "../pages/Charts/ApexCharts/TreemapCharts";
import PieCharts from "../pages/Charts/ApexCharts/PieCharts";
import RadialbarCharts from "../pages/Charts/ApexCharts/RadialbarCharts";
import RadarCharts from "../pages/Charts/ApexCharts/RadarCharts";
import PolarCharts from "../pages/Charts/ApexCharts/PolarCharts";
import ChartsJs from "../pages/Charts/ChartsJs/index";
import Echarts from "../pages/Charts/ECharts/index";

// //Job pages
import Statistics from "../pages/Jobs/Statistics";
import JobList from "../pages/Jobs/JobList/List";
import JobGrid from "../pages/Jobs/JobList/Grid";
import JobOverview from "../pages/Jobs/JobList/Overview";
import CandidateList from "../pages/Jobs/CandidateList/ListView";
import CandidateGrid from "../pages/Jobs/CandidateList/GridView";
import NewJobs from "../pages/Jobs/NewJob";
import JobCategories from "../pages/Jobs/JobCategories";
import Application from "../pages/Jobs/Application";
import CompaniesList from "../pages/Jobs/CompaniesList";

// Landing Index
import OnePage from "../pages/Landing/OnePage";
import NFTLanding from "../pages/Landing/NFTLanding";
import JobLanding from "../pages/Job_Landing/Job";

import PublicBookingPage from "../pages/Public/Booking";
import PublicAppointmentManagePage from "../pages/Public/AppointmentManage";
import PublicAppointmentReviewPage from "../pages/Public/AppointmentReview";
import PublicLoyaltyProgressPage from "../pages/Public/LoyaltyProgress";
import PublicClubJoinPage from "../pages/Public/ClubJoin";
import PublicClubPlansPage from "../pages/Public/ClubPlans";
import LoyaltyCardsPage from "../pages/Adatis/Studio/LoyaltyCards";

import PublicEmailUnsubscribePage from "../pages/Public/EmailUnsubscribe";
import PublicCsNurtureUnsubscribePage from "../pages/Public/CsNurtureUnsubscribe";
import PublicQuotePage from "../pages/Public/Quote";
import StudioPublicPage from "../pages/Public/Studio/StudioPublicPage";
import ReviewsPage from "../pages/Adatis/Studio/Reviews";
import PrivacyPolicy from '../pages/Pages/PrivacyPolicy';
import TermsCondition from '../pages/Pages/TermsCondition';

// // User Profile
import UserProfile from "../pages/Authentication/user-profile";

import RangeArea from "../pages/Charts/ApexCharts/RangeAreaCharts/Index";
import FunnelChart from "../pages/Charts/ApexCharts/FunnelCharts/Index";
import FileManager from "../pages/FileManager";
import ToDoList from "../pages/ToDo";
import UiLink from "../pages/BaseUi/UiLinks/UiLinks";
import Kanbanboard from "pages/Tasks/KanbanBoard";
import BlogListView from "pages/Pages/Blogs/ListView";
import BlogGridView from "pages/Pages/Blogs/GridView";
import PageBlogOverview from "pages/Pages/Blogs/Overview";
import SlopeCharts from "pages/Charts/ApexCharts/SlopeCharts";
import DashboardBlog from "pages/DashboardBlog";

import {
  ADMIN_ROLES,
  AGENDA_WEB_ROLES,
  CLIENTS_WEB_ROLES,
  OPERATIONAL_ROLES,
  SDR_WEB_ROLES,
  STUDIO_WEB_ROLES,
} from "./roleAccess";
import { PlanFeatureKey } from "../services/sessionCapabilitiesService";

export interface AuthProtectedRoute {
  path: string;
  component: React.ReactElement;
  exact?: boolean;
  allowedRoles?: string[];
  /** Plan feature required to access the route (doc 10 § 3.0.2). */
  requiredPlanFeature?: PlanFeatureKey | string;
}

const authProtectedRoutes: AuthProtectedRoute[] = [
  { path: "/dashboard-analytics", component: <DashboardAnalytics /> },
  { path: "/dashboard-crm", component: <DashboardCrm /> },
  { path: "/dashboard", component: <StudioDashboard />, allowedRoles: SDR_WEB_ROLES },
  { path: "/index", component: <StudioDashboard />, allowedRoles: SDR_WEB_ROLES },
  { path: "/dashboard-crypto", component: <DashboardCrypto /> },
  { path: "/dashboard-projects", component: <DashboardProject /> },
  { path: "/dashboard-nft", component: <DashboardNFT /> },
  { path: "/dashboard-job", component: <DashboardJob /> },
  { path: "/dashboard-blog", component: <DashboardBlog /> },

  // apps
  { path: "/apps-calendar", component: <Calendar /> },
  { path: "/apps-calendar-month-grid", component: <MonthGrid /> },
  { path: "/apps-ecommerce-products", component: <EcommerceProducts /> },
  { path: "/apps-ecommerce-product-details/:_id", component: <EcommerceProductDetail /> },
  { path: "/apps-ecommerce-product-details", component: <EcommerceProductDetail /> },
  { path: "/apps-ecommerce-add-product", component: <EcommerceAddProduct /> },
  { path: "/apps-ecommerce-orders", component: <EcommerceOrders /> },
  { path: "/apps-ecommerce-order-details", component: <EcommerceOrderDetail /> },
  { path: "/apps-ecommerce-customers", component: <EcommerceCustomers /> },
  { path: "/apps-ecommerce-cart", component: <EcommerceCart /> },
  { path: "/apps-ecommerce-checkout", component: <EcommerceCheckout /> },
  { path: "/apps-ecommerce-sellers", component: <EcommerceSellers /> },
  { path: "/apps-ecommerce-seller-details", component: <EcommerceSellerDetail /> },

  { path: "/apps-file-manager", component: <FileManager /> },
  { path: "/apps-todo", component: <ToDoList /> },


  // //Chat
  { path: "/apps-chat", component: <Chat /> },

  // //EMail
  { path: "/apps-mailbox", component: <MailInbox /> },
  { path: "/apps-email-basic", component: <BasicAction /> },
  { path: "/apps-email-ecommerce", component: <EcommerceAction /> },

  // //Projects
  { path: "/apps-projects-list", component: <ProjectList /> },
  { path: "/apps-projects-overview", component: <ProjectOverview /> },
  { path: "/apps-projects-create", component: <CreateProject /> },

  // //Task
  { path: "/apps-tasks-kanban", component: <Kanbanboard /> },
  { path: "/apps-tasks-list-view", component: <TaskList /> },
  { path: "/apps-tasks-details", component: <TaskDetails /> },

  // //Api Key
  { path: "/apps-api-key", component: <APIKey /> },

  // //Crm
  { path: "/apps-crm-contacts", component: <CrmContacts /> },
  { path: "/apps-crm-companies", component: <CrmCompanies /> },
  { path: "/apps-crm-deals", component: <CrmDeals /> },
  { path: "/apps-crm-leads", component: <CrmLeads /> },

  // //Invoices
  { path: "/apps-invoices-list", component: <InvoiceList /> },
  { path: "/apps-invoices-details", component: <InvoiceDetails /> },
  { path: "/apps-invoices-create", component: <InvoiceCreate /> },

  // //Supports Tickets
  { path: "/apps-tickets-list", component: <ListView /> },
  { path: "/apps-tickets-details", component: <TicketsDetails /> },

  // //transactions
  { path: "/apps-crypto-transactions", component: <Transactions /> },
  { path: "/apps-crypto-buy-sell", component: <BuySell /> },
  { path: "/apps-crypto-orders", component: <CryproOrder /> },
  { path: "/apps-crypto-wallet", component: <MyWallet /> },
  { path: "/apps-crypto-ico", component: <ICOList /> },
  { path: "/apps-crypto-kyc", component: <KYCVerification /> },

  // // NFT Marketplace
  { path: "/apps-nft-marketplace", component: <Marketplace /> },
  { path: "/apps-nft-collections", component: <Collections /> },
  { path: "/apps-nft-create", component: <CreateNFT /> },
  { path: "/apps-nft-creators", component: <Creators /> },
  { path: "/apps-nft-explore", component: <ExploreNow /> },
  { path: "/apps-nft-item-details", component: <ItemDetails /> },
  { path: "/apps-nft-auction", component: <LiveAuction /> },
  { path: "/apps-nft-ranking", component: <Ranking /> },
  { path: "/apps-nft-wallet", component: <WalletConnect /> },

  // //charts
  { path: "/charts-apex-line", component: <LineCharts /> },
  { path: "/charts-apex-area", component: <AreaCharts /> },
  { path: "/charts-apex-column", component: <ColumnCharts /> },
  { path: "/charts-apex-bar", component: <BarCharts /> },
  { path: "/charts-apex-mixed", component: <MixedCharts /> },
  { path: "/charts-apex-timeline", component: <TimelineCharts /> },
  { path: "/charts-apex-range-area", component: <RangeArea /> },
  { path: "/charts-apex-funnel", component: <FunnelChart /> },
  { path: "/charts-apex-candlestick", component: <CandlestickChart /> },
  { path: "/charts-apex-boxplot", component: <BoxplotCharts /> },
  { path: "/charts-apex-bubble", component: <BubbleChart /> },
  { path: "/charts-apex-scatter", component: <ScatterCharts /> },
  { path: "/charts-apex-heatmap", component: <HeatmapCharts /> },
  { path: "/charts-apex-treemap", component: <TreemapCharts /> },
  { path: "/charts-apex-pie", component: <PieCharts /> },
  { path: "/charts-apex-radialbar", component: <RadialbarCharts /> },
  { path: "/charts-apex-radar", component: <RadarCharts /> },
  { path: "/charts-apex-polar", component: <PolarCharts /> },
  { path: "/charts-apex-slope", component: <SlopeCharts /> },

  { path: "/charts-chartjs", component: <ChartsJs /> },
  { path: "/charts-echarts", component: <Echarts /> },


  // // Base Ui
  { path: "/ui-alerts", component: <UiAlerts /> },
  { path: "/ui-badges", component: <UiBadges /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-dropdowns", component: <UiDropdowns /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-tabs", component: <UiTabs /> },
  { path: "/ui-accordions", component: <UiAccordions /> },
  { path: "/ui-modals", component: <UiModals /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },
  { path: "/ui-placeholders", component: <UiPlaceholders /> },
  { path: "/ui-progress", component: <UiProgress /> },
  { path: "/ui-notifications", component: <UiNotifications /> },
  { path: "/ui-media", component: <UiMediaobject /> },
  { path: "/ui-embed-video", component: <UiEmbedVideo /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-lists", component: <UiList /> },
  { path: "/ui-links", component: <UiLink /> },
  { path: "/ui-general", component: <UiGeneral /> },
  { path: "/ui-ribbons", component: <UiRibbons /> },
  { path: "/ui-utilities", component: <UiUtilities /> },

  // // Advance Ui
  { path: "/advance-ui-scrollbar", component: <UiScrollbar /> },
  { path: "/advance-ui-animation", component: <UiAnimation /> },
  { path: "/advance-ui-swiper", component: <UiSwiperSlider /> },
  { path: "/advance-ui-ratings", component: <UiRatings /> },
  { path: "/advance-ui-highlight", component: <UiHighlight /> },

  // // Widgets
  { path: "/widgets", component: <Widgets /> },

  // // Forms
  { path: "/forms-elements", component: <BasicElements /> },
  { path: "/forms-select", component: <FormSelect /> },
  { path: "/forms-checkboxes-radios", component: <CheckBoxAndRadio /> },
  { path: "/forms-pickers", component: <FormPickers /> },
  { path: "/forms-masks", component: <Masks /> },
  { path: "/forms-advanced", component: <FormAdvanced /> },
  { path: "/forms-range-sliders", component: <FormRangeSlider /> },
  { path: "/forms-validation", component: <FormValidation /> },
  { path: "/forms-wizard", component: <FormWizard /> },
  { path: "/forms-editors", component: <FormEditor /> },
  { path: "/forms-file-uploads", component: <FileUpload /> },
  { path: "/forms-layouts", component: <Formlayouts /> },
  { path: "/forms-select2", component: <Select2 /> },

  // //Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-react", component: <ReactTable /> },

  // //Icons
  { path: "/icons-remix", component: <RemixIcons /> },
  { path: "/icons-boxicons", component: <BoxIcons /> },
  { path: "/icons-materialdesign", component: <MaterialDesign /> },
  { path: "/icons-feather", component: <FeatherIcons /> },
  { path: "/icons-lineawesome", component: <LineAwesomeIcons /> },
  { path: "/icons-crypto", component: <CryptoIcons /> },

  // //Maps
  { path: "/maps-google", component: <GoogleMaps /> },

  // //Pages
  { path: "/pages-starter", component: <Starter /> },
  { path: "/pages-profile", component: <SimplePage /> },
  { path: "/pages-profile-settings", component: <Settings /> },
  { path: "/pages-team", component: <Team /> },
  { path: "/pages-timeline", component: <Timeline /> },
  { path: "/pages-faqs", component: <Faqs /> },
  { path: "/pages-gallery", component: <Gallery /> },
  { path: "/pages-pricing", component: <Pricing /> },
  { path: "/pages-sitemap", component: <SiteMap /> },
  { path: "/pages-search-results", component: <SearchResults /> },
  { path: "/pages-privacy-policy", component: <PrivacyPolicy /> },
  { path: "/pages-terms-condition", component: <TermsCondition /> },
  { path: "/pages-blog-list", component: <BlogListView /> },
  { path: "/pages-blog-grid", component: <BlogGridView /> },
  { path: "/pages-blog-overview", component: <PageBlogOverview /> },

  // //Job pages
  { path: "/apps-job-statistics", component: <Statistics /> },
  { path: "/apps-job-lists", component: <JobList /> },
  { path: "/apps-job-grid-lists", component: <JobGrid /> },
  { path: "/apps-job-details", component: <JobOverview /> },
  { path: "/apps-job-candidate-lists", component: <CandidateList /> },
  { path: "/apps-job-candidate-grid", component: <CandidateGrid /> },
  { path: "/apps-job-application", component: <Application /> },
  { path: "/apps-job-new", component: <NewJobs /> },
  { path: "/apps-job-companies-lists", component: <CompaniesList /> },
  { path: "/apps-job-categories", component: <JobCategories /> },



  //User Profile
  { path: "/profile", component: <UserProfile /> },

  // Adatis — Cadastros
  { path: "/clients/:clientId", component: <ClientDetail />, allowedRoles: CLIENTS_WEB_ROLES },
  { path: "/clients", component: <ClientsList />, allowedRoles: CLIENTS_WEB_ROLES },
  { path: "/crm", component: <CrmPage />, allowedRoles: STUDIO_WEB_ROLES, requiredPlanFeature: "crm" },
  { path: "/professionals", component: <ProfessionalsList />, allowedRoles: STUDIO_WEB_ROLES },
  { path: "/agenda", component: <AgendaList />, allowedRoles: AGENDA_WEB_ROLES },
  { path: "/reviews", component: <ReviewsPage />, allowedRoles: AGENDA_WEB_ROLES },
  { path: "/consulta", component: <CounterLookup />, allowedRoles: ["receptionist"] },
  { path: "/orders/:orderId", component: <OrdersList />, allowedRoles: STUDIO_WEB_ROLES },
  { path: "/orders", component: <OrdersList />, allowedRoles: STUDIO_WEB_ROLES },
  { path: "/products/valuation", component: <InventoryValuationPage />, allowedRoles: ADMIN_ROLES, requiredPlanFeature: "inventory" },
  { path: "/products", component: <ProductsList />, allowedRoles: ADMIN_ROLES, requiredPlanFeature: "inventory" },
  { path: "/financial/expenses", component: <ExpensesList />, allowedRoles: ADMIN_ROLES, requiredPlanFeature: "expenses_dre" },
  { path: "/financial/dre", component: <DreReport />, allowedRoles: ADMIN_ROLES, requiredPlanFeature: "expenses_dre" },
  { path: "/financial/day-close", component: <DayCloseReportPage />, allowedRoles: ADMIN_ROLES, requiredPlanFeature: "expenses_dre" },
  { path: "/services", component: <ServicesList />, allowedRoles: ADMIN_ROLES },
  { path: "/service-bundles", component: <ServiceBundlesList />, allowedRoles: ADMIN_ROLES },
  { path: "/service-packages", component: <ServicePackagesList />, allowedRoles: ADMIN_ROLES },
  { path: "/loyalty-cards", component: <LoyaltyCardsPage />, allowedRoles: ADMIN_ROLES },
  { path: "/client-subscription-plans", component: <ClientSubscriptionPlansList />, allowedRoles: ADMIN_ROLES },

  { path: "/units", component: <UnitsList />, allowedRoles: ADMIN_ROLES },
  { path: "/users", component: <UsersList />, allowedRoles: ADMIN_ROLES },
  { path: "/settings/integrations", component: <IntegrationsPage />, allowedRoles: ADMIN_ROLES, requiredPlanFeature: "integrations_app_store" },
  { path: "/settings/anamnesis-templates", component: <AnamnesisTemplatesPage />, allowedRoles: ADMIN_ROLES, requiredPlanFeature: "anamnesis" },
  { path: "/settings/catalog-categories", component: <CatalogCategoriesPage />, allowedRoles: ADMIN_ROLES },
  { path: "/settings/client-tags", component: <ClientTagsPage />, allowedRoles: ADMIN_ROLES },
  { path: "/settings/clinical-map-regions", component: <ClinicalMapRegionsPage />, allowedRoles: ADMIN_ROLES },
  { path: "/settings/clinical-checklist-templates", component: <ClinicalChecklistTemplatesPage />, allowedRoles: ADMIN_ROLES },
  { path: "/settings/general", component: <GeneralSettings />, allowedRoles: ADMIN_ROLES },
  { path: "/settings/visual-lab", component: <VisualLabPage />, allowedRoles: ADMIN_ROLES },
  { path: "/settings/operation", component: <OperationSettings />, allowedRoles: ADMIN_ROLES },
  { path: "/settings/payments", component: <PaymentSettingsPage />, allowedRoles: ADMIN_ROLES },
  {
    path: "/settings/email-notifications",
    component: <EmailNotificationsSettingsPage />,
    allowedRoles: ADMIN_ROLES,
  },
  {
    path: "/marketing/contact-ruler",
    component: <ContactRulerPage />,
    allowedRoles: ADMIN_ROLES,
  },
  {
    path: "/marketing/email-campaigns",
    component: <EmailCampaignsPage />,
    allowedRoles: ADMIN_ROLES,
  },

  {
    path: "/settings/messaging",
    component: <MessagingSettingsPage />,
    allowedRoles: ADMIN_ROLES,
    requiredPlanFeature: "whatsapp_lite",
  },
  {
    path: "/settings/whatsapp-extension",
    component: <WhatsappExtensionSettingsPage />,
    allowedRoles: ADMIN_ROLES,
  },
  { path: "/settings/team-permissions", component: <TeamPermissionsPage />, allowedRoles: ADMIN_ROLES },
  { path: "/settings/calendar-exceptions", component: <CalendarExceptionsPage />, allowedRoles: ADMIN_ROLES },
  { path: "/settings/account", component: <AccountSettings />, allowedRoles: OPERATIONAL_ROLES },
  { path: "/settings/subscription", component: <SubscriptionSettings />, allowedRoles: ADMIN_ROLES },
  { path: "/help", component: <HelpPage />, allowedRoles: OPERATIONAL_ROLES },
  { path: "/support/chat", component: <SupportChatPage />, allowedRoles: STUDIO_WEB_ROLES },
  { path: "/support/tickets", component: <SupportTicketsPage />, allowedRoles: ADMIN_ROLES },
  { path: "/support/tickets/:ticketId", component: <SupportTicketsPage />, allowedRoles: ADMIN_ROLES },

  // Adatis — Shared
  { path: "/suspended", component: <Suspended />, allowedRoles: OPERATIONAL_ROLES },
  { path: "/billing", component: <Billing />, allowedRoles: ["owner"] },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const superAdminProtectedRoutes = [
  { path: "/super-admin/dashboard", component: <SuperAdminDashboard /> },
  { path: "/super-admin/plans", component: <SuperAdminPlans /> },
  { path: "/super-admin/promotion-coupons", component: <SuperAdminPromotionCoupons /> },
  { path: "/super-admin/blog", component: <SuperAdminBlog /> },
  { path: "/super-admin/health-record-presets", component: <SuperAdminHealthRecordPresets /> },
  { path: "/super-admin/tenants", component: <SuperAdminTenants /> },
  { path: "/super-admin/tenants/:tenantId/team", component: <SuperAdminTenantTeam /> },
  { path: "/super-admin/accounts", component: <SuperAdminAccounts /> },
  { path: "/super-admin/trial-queue", component: <SuperAdminTrialQueue /> },
  { path: "/super-admin/cs-nurture", component: <SuperAdminCsNurture /> },
  { path: "/super-admin/concierge", component: <SuperAdminConcierge /> },
  { path: "/super-admin/activity-logs", component: <SuperAdminActivityLogs /> },
  { path: "/super-admin/webhook-logs", component: <SuperAdminWebhookLogs /> },
  { path: "/super-admin/support/tickets", component: <SuperAdminSupportTickets /> },
  { path: "/super-admin/support/tickets/:ticketId", component: <SuperAdminSupportTickets /> },
  { path: "/super-admin/support/conversations", component: <SuperAdminSupportConversations /> },
  {
    path: "/super-admin/support/conversations/:conversationId",
    component: <SuperAdminSupportConversations />,
  },
  { path: "/super-admin/email-suppressions", component: <SuperAdminEmailSuppressions /> },
  {
    path: "/super-admin",
    exact: true,
    component: <Navigate to="/super-admin/dashboard" />,
  },
  { path: "/super-admin/*", component: <Navigate to="/super-admin/dashboard" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/auth/google/callback", component: <GoogleCallback /> },
  { path: "/auth/google/mobile-callback", component: <GoogleMobileCallback /> },
  { path: "/invite-setup", component: <InviteSetup /> },
  { path: "/select-studio", component: <SelectStudio /> },
  { path: "/super-admin/login", component: <SuperAdminLogin /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },

  // //AuthenticationInner pages
  { path: "/auth-signin-basic", component: <BasicSignIn /> },
  { path: "/auth-signin-cover", component: <CoverSignIn /> },
  { path: "/auth-signup-basic", component: <BasicSignUp /> },
  { path: "/auth-signup-cover", component: <CoverSignUp /> },
  { path: "/auth-pass-reset-basic", component: <BasicPasswReset /> },
  { path: "/auth-pass-reset-cover", component: <CoverPasswReset /> },
  { path: "/auth-lockscreen-basic", component: <BasicLockScreen /> },
  { path: "/auth-lockscreen-cover", component: <CoverLockScreen /> },
  { path: "/auth-logout-basic", component: <BasicLogout /> },
  { path: "/auth-logout-cover", component: <CoverLogout /> },
  { path: "/auth-success-msg-basic", component: <BasicSuccessMsg /> },
  { path: "/auth-success-msg-cover", component: <CoverSuccessMsg /> },
  { path: "/auth-twostep-basic", component: <BasicTwosVerify /> },
  { path: "/auth-twostep-cover", component: <CoverTwosVerify /> },
  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-404-cover", component: <Cover404 /> },
  { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },

  { path: "/landing", component: <OnePage /> },
  { path: "/nft-landing", component: <NFTLanding /> },
  { path: "/job-landing", component: <JobLanding /> },

  { path: "/auth-pass-change-basic", component: <BasicPasswCreate /> },
  { path: "/auth-pass-change-cover", component: <CoverPasswCreate /> },
  { path: "/auth-offline", component: <Offlinepage /> },

  { path: "/book/:token", component: <PublicBookingPage /> },
  { path: "/a/:token", component: <PublicAppointmentManagePage /> },
  { path: "/r/:token", component: <PublicAppointmentReviewPage /> },
  { path: "/l/:token", component: <PublicLoyaltyProgressPage /> },
  { path: "/club/plans/:bookingToken", component: <PublicClubPlansPage /> },
  { path: "/club/:token", component: <PublicClubJoinPage /> },

  { path: "/q/:token", component: <PublicQuotePage /> },
  { path: "/s/:slug", component: <StudioPublicPage /> },
  { path: "/email/unsubscribe", component: <PublicEmailUnsubscribePage /> },
  { path: "/cs/unsubscribe", component: <PublicCsNurtureUnsubscribePage /> },

  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-coming-soon", component: <ComingSoon /> },

];

export { authProtectedRoutes, publicRoutes, superAdminProtectedRoutes };